import * as React from "react";
import { useHubx } from "../../../HubX";
import MaterialDatePickerPairComponent from "../../../components/MaterialDateTimePickerPair";
import { IEnumerable, NullableDate } from "../../../core/models/ModelHelpers";
import { EVENT_DATEPICKER_CHANGE } from "../../../Events";
import { DateWindow } from "../../../core/models/DateWindow";
import uuidv4 from "../../../helpers/uuid";

type MaterialDatePickerPairProps = {
  startDate?: Date;
  endDate?: Date;
  id?: IEnumerable;
};

function MaterialDatePickerPair({ startDate, endDate, id }: MaterialDatePickerPairProps) {
  const useId = id ? id : uuidv4();
  const hub = useHubx();

  const [datewindow, setDateWindow] = React.useState<DateWindow>(() => {
    const initialDate = startDate || new Date();
    const finalDate = endDate || new Date();

    return { start: initialDate, end: finalDate };
  });

  React.useEffect(() => {
    hub.notify(EVENT_DATEPICKER_CHANGE(useId), datewindow);
  }, [hub, datewindow, useId]);

  function handleChange(date: NullableDate, key: string) {
    setDateWindow((prev) => {
      return { ...prev, [key]: date };
    });
  }

  return (
    <MaterialDatePickerPairComponent
      id={id}
      onChangeEnd={(date: NullableDate) => handleChange(date, "end")}
      onChangeStart={(date: NullableDate) => handleChange(date, "start")}
      start={datewindow.start}
      end={datewindow.end}
    />
  );
}

export default MaterialDatePickerPair;
